var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sj-scrollBar",on:{"scroll":_vm.handleScroll}},[_c('div',{staticClass:"sj-scrollBar-list"},_vm._l((_vm.data),function(item,index){return _c('div',{key:item.value,ref:("item" + index),refInFor:true,class:[
        'sj-scrollBar-item',
        {
          selected: item.value === _vm.currentValue
        }
      ],style:({
        height: (_vm.itemHeight + "px"),
        lineHeight: (_vm.itemHeight + "px"),
        marginTop: index === 0 ? ((_vm.itemHeight * _vm.selectedIndex) + "px") : null,
        marginBottom:
          index === _vm.data.length - 1
            ? ((_vm.height - _vm.itemHeight * (_vm.selectedIndex + 1)) + "px")
            : null
      }),on:{"click":function($event){return _vm.handleClick(index, item)}}},[_vm._v(" "+_vm._s(item.label)+" ")])}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }